import { useState, useCallback, useMemo } from 'react';

export interface UseDialog {
  open: boolean;
  handleOpen: () => void;
  handleClose: () => void;
}

export const useDialogInitialState: UseDialog = {
  open: false,
  handleOpen: () => {},
  handleClose: () => {},
};

export const useDialog = (): UseDialog => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  // 🔒 ESTABILIZACIÓN: Memoizar el objeto para evitar recreaciones innecesarias
  return useMemo(
    () => ({
      open,
      handleOpen,
      handleClose,
    }),
    [open, handleOpen, handleClose],
  );
};

export default useDialog;
